import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { IFileStoreItem } from '../../documents/interfaces/IFileStoreItem';
import { ResponseContentType, ResponseType } from '@angular/http';
import { IFileService } from './interfaces/iFileService';
import { IFileInfo } from './interfaces/IFileInfo';

@Injectable()
export class FileUploadService implements IFileService  {
  /**
   *
   */
  constructor(
    private http: HttpClient,
    @Inject('BASE_URL') private rootUrl: string
  ) {}
  Delete(file: IFileStoreItem):Observable<any> {
    const url = '/File';
    const params = {};
    params['container'] = file.container;
    if (!file.id) {
      const newLocal = 'id is not provided';
      throw newLocal;
    }
    params['id'] = file.id;
    if (file.partition) {
      params['partition'] = file.partition;
    }
    return this.http.delete(`${this.rootUrl}${url}`, {params: params});
  }
  Recreate(fileInfo: IFileInfo): Observable<IFileStoreItem[]> {
    if (fileInfo && fileInfo.container && fileInfo.id) {
      return this.http.post<IFileStoreItem[]>(`${this.rootUrl}/File/${fileInfo.container}/${fileInfo.id}/variants/recreate`,null);
    }
  }  
  Get(fileInfo: IFileInfo): Observable<IFileStoreItem> {
    if (fileInfo && fileInfo.container && fileInfo.id) {
      const params = {};
      if (fileInfo.partition) {
        params['partition'] = fileInfo.partition;
      }
      return this.http.get<IFileStoreItem>(`${this.rootUrl}/File/${fileInfo.container}/${fileInfo.id}`, {params: params});
    }
  }
  GetVariant(fileInfo: IFileInfo): Observable<IFileStoreItem> {
    if (fileInfo && fileInfo.container && fileInfo.id && fileInfo.variant) {
      return this.http.get<IFileStoreItem>(`${this.rootUrl}/File/${fileInfo.container}/${fileInfo.id}/variants/${fileInfo.variant}`);
    }
  }
  GetLink(file: IFileInfo) {
    let url: string = '/File/Download?container=' + file.container;
    if (!file.id) {
      throw new Error('id is not prived');
    }
    url += '&id=' + file.id;
    if (file.partition) {
      url += '&partition=' + file.partition;
    }
    return `${this.rootUrl}${url}`;
  }
  GetVariantLink(file: IFileInfo) {
    let url: string = null;
    if (file.id && file.container && file.variant) {
      url = `/File/Download/${file.container}/${file.id}-${file.variant}?partition=${file.id}`;
      return `${this.rootUrl}${url}`;
    }
    else  {
      return null;
    }
  }

  Download(file: IFileStoreItem): Observable<Blob> {
    let url: string = '/File/Download?container=' + file.container;
    if (!file.id) {
      throw Error('id is not prived');
    }
    url += '&id=' + file.id;
    if (file.partition) {
      url += '&partition=' + file.partition;
    }


    return this.http.get(`${this.rootUrl}${url}`, {
      responseType: 'blob'
    });
  }
  UploadOne(file: File, container?: string, partition?: string, name?:string): Observable<any> {
    const params = {};
    const headers = {};
    params['container'] = container || null;
    if (partition) {
      params['partition'] = partition;
    }
    if(name){
      headers['fileName'] = name;
    }
    const formData: FormData = new FormData();
    formData.append('file', file);
    return this.http.post(`${this.rootUrl}/File/Upload/One`, formData, {
      params: params,
      headers:headers,
      reportProgress: true,
      observe: 'events'
    });
  }
  UploadMany(files: FileList, container?: string, partition?: string): Observable<any> {
    const params = {};
    params['container'] = container || null;
    if (partition) {
      params['partition'] = partition;
    }
    const formData: FormData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append('file', files[i]);
      return this.http.post(`${this.rootUrl}/File/Upload/Manny`, formData, {params: params});
    }
  }

}
